import {AbstractModel} from "./abstract-model";

export class Right extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  roleView: string | null = null;
  roleUpdate: string | null = null;
  roleAccess: string | null = null;
}
